module.exports = __webpack_public_path__ + "img/decor1.ad4e1fb9.svg";